(function () {
  'use strict'

  /**
   * @ngdoc service
   * @name Cart
   * @module thismoment.glow.component.glow-cart.service
   *
   * @description
   * Manages Glow Cart cookie and state between Glow and Cart components.
   */

  const MODULE_NAME = 'thismoment.glow.component.glow-cart.service.glow-cart'

  require('angular')
    .module(MODULE_NAME, [
      require('angular-cookies'),
      require('../../../../content')
    ])
    .service('Cart', cartService)

  cartService.$inject = ['$cookies', '$rootScope', 'GlowConfig']
  function cartService ($cookies, $rootScope, GlowConfig) {
    const cookieName = 'tm_' + GlowConfig.get('subdomain') + '_cart'
    const cartItems = getCookie() || []

    return {
      addItem: addItem,
      removeItem: removeItem,
      hasItem: hasItem,
      getItemPosition: getItemPosition,
      empty: empty,
      setIds: setIds,
      getIds: getIds
    }

    function addItem (id) {
      if (angular.isNumber(id)) {
        id = id.toString()
      }
      cartItems.push(id)
      $rootScope.$emit('cart:add', id)

      return setCookie()
    }

    function removeItem (id) {
      if (angular.isNumber(id)) {
        id = id.toString()
      }
      var idxToRemove = cartItems.indexOf(id)
      cartItems.splice(idxToRemove, 1)
      $rootScope.$emit('cart:remove', id)
      setCookie()

      return idxToRemove
    }

    function hasItem (id) {
      if (angular.isNumber(id)) {
        id = id.toString()
      }
      return (cartItems.indexOf(id) !== -1)
    }

    function getItemPosition (id) {
      if (angular.isNumber(id)) {
        id = id.toString()
      }
      return cartItems.indexOf(id)
    }

    function empty () {
      for (var i = cartItems.length - 1; i >= 0; i--) {
        removeItem(cartItems[i])
      }

      setCookie()
    }

    function setIds (ids) {
      cartItems.length = 0
      angular.forEach(ids, (id) => {
        cartItems.push(id)
      })
      $rootScope.$emit('cart:reorder')
      setCookie()
    }

    function getIds () {
      return cartItems
    }

    function setCookie () {
      $cookies.putObject(cookieName, cartItems)
      return getCookie()
    }

    function getCookie () {
      return $cookies.getObject(cookieName)
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-cart/service/glow-cart.js